import React from 'react';

const Logo = (props) => {
  return (
    <img alt="Logo" src="/static/images/logos/vertical_logo.png" {...props} />
  );
};

export default Logo;
